import "./cerimony-style.css";

const Libretto = () => {

  return (
    <section 
        className="libretto-section"
    >
        <div className="libretto-chapter">
            <h1>
            CANTO INIZIALE
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            COME UN PRODIGIO
          </h2>
        </div>
        <div className="libretto-body">
        Signore tu mi scruti e conosci<br/> 
        Sai quando seggo e quando mi alzo <br/> 
        Riesci a vedere i miei pensieri<br/> 
        Sai quando io cammino e quando riposo<br/> 
        Ti sono note tutte le mie vie<br/> 
        La mia parola non è ancora sulla lingua <br/> 
        E tu, Signore, già la conosci tutta<br/> 
        <div className="libretto-rit">RIT: Sei tu che mi hai creato<br/> 
        <div className="libretto-rit2">E mi hai tessuto nel seno di mia madre <br/> 
        Tu mi hai fatto come un prodigio<br/> 
        Le tue opere sono stupende<br/> 
        E per questo ti lodo</div></div><br/> 
        Di fronte e alle spalle tu mi circondi <br/> 
        Poni su me la tua mano<br/> 
        La tua saggezza, stupenda per me <br/> 
        È troppo alta e io non la comprendo<br/> 
        Che sia in cielo o agli inferi, ci sei<br/> 
        Non si può mai fuggire dalla tua presenza <br/> 
        Ovunque la tua mano guiderà la mia<br/> 
        <div className="libretto-rit">RIT.</div> 
        E nel segreto tu mi hai formato<br/> 
        Mi hai intessuto dalla terra<br/> 
        Neanche le ossa ti eran nascoste<br/> 
        Ancora informe mi hanno visto i tuoi occhi<br/> 
        I miei giorni erano fissati<br/> 
        Quando ancora non ne esisteva uno<br/> 
        E tutto quanto era scritto nel tuo libro<br/> 
        <div className="libretto-rit">RIT.</div>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            MEMORIA DEL BATTESIMO
          </h2>
        </div>
        <div className="libretto-body">
        Elisa e Giovanni,<br/> 
        la Chiesa partecipa alla vostra gioia e insieme con i vostri cari vi accoglie con grande affetto nel giorno in cui davanti a Dio, nostro Padre, decidete di realizzare la comunione di tutta la vita.<br/> <br/> 
        In questo giorno per voi di festa il Signore vi ascolti.<br/> 
        Mandi dal cielo il suo aiuto e vi custodisca.<br/> 
        Realizzi i desideri del vostro cuore ed esaudisca le vostre preghiere.<br/> <br/> 
        Riconoscenti per essere divenuti figli nel Figlio, facciamo ora memoria del Battesimo, dal quale, come da seme fecondo, nasce e prende vigore l' impegno di vivere fedeli nell' amore.<br/> <br/> 
        Padre,<br/> 
        nel Battesimo del tuo Figlio Gesù al fiume Giordano<br/> 
        hai rivelato al mondo l' amore sponsale per il tuo popolo.<br/> 
        <div className="libretto-risposta">- Noi ti lodiamo e ti rendiamo grazie</div><br/>
        Cristo Gesù,<br/> 
        dal tuo costato aperto sulla Croce hai generato la Chiesa,<br/> 
        tua diletta sposa.<br/> 
        <div className="libretto-risposta">- Noi ti lodiamo e ti rendiamo grazie</div><br/>
        Spirito Santo,<br/> 
        potenza del Padre e del Figlio,<br/> 
        oggi fai risplendere in Elisa e Giovanni la veste nuziale della Chiesa.<br/> 
        <div className="libretto-risposta">- Noi ti lodiamo e ti rendiamo grazie</div><br/>
        Dio onnipotente, origine e fonte della vita, che ci hai rigenerati nell' acqua con la potenza del tuo Spirito, ravviva in tutti noi la grazia del Battesimo<br/> 
        e concedi a Elisa e Giovanni un cuore libero e una fede ardente perché, purificati nell' intimo, accolgano il dono del matrimonio, nuova via della loro santificazione.<br/> 
        Per Cristo, nostro Signore. 
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        <div className="libretto-chapter">
            <h2>
            GLORIA
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">
        RIT: Gloria a Dio nell' alto dei cieli<br/>
        <div className="libretto-rit2">Pace in terra agli uomini amati dal Signor. <br/>
        Gloria a Dio nell' alto dei cieli<br/>
        Pace in terra agli uomini amati dal Signor. (x2)<br/>
        </div></div>  <br/>
        Noi ti lodiamo <span style={{ fontStyle: 'italic' }}>&nbsp;&nbsp;Ti benediciamo,</span> <br/>
        Ti adoriamo, <span style={{ fontStyle: 'italic' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ti glorifichiamo,</span> <br/>
        Ti rendiamo grazie<br/>
        Per la tua immensa Gloria<br/><br/>
        Signore Dio, Gloria.<br/>
        Re del cielo, Gloria.<br/>
        Dio Padre, Dio-Onnipotente, Gloria <br/>
        Signore Figlio unigenito<br/>
        Gesù Cristo, Signore Dio,<br/>
        Agnello di Dio, Figlio del Padre, Gloria.<br/>
        <div className="libretto-rit">RIT.</div>
        Tu che togli i peccati del mondo, <br/>
        Abbi pietà di noi,<br/>
        Tu che togli i peccati del mondo, <br/>
        Accogli la nostra supplica,<br/>
        Tu che siedi alla destra del Padre,<br/>
        Abbi pietà di noi,<br/>
        Perché Tu solo il Santo, Tu solo il Signore, <br/>
        Tu solo l'Altissimo Gesù Cristo,<br/>
        Con lo Spirito Santo,<br/>
        Nella Gloria di Dio Padre.
        <div className="libretto-rit">RIT.</div>
        </div>

        <div className="libretto-chapter">
            <h2>
            COLLETTA
          </h2>
        </div>
        <div className="libretto-body">
        O Dio, che in questo grande sacramento hai consacrato il patto coniugale, per rivelare nell' unione degli sposi il mistero di Cristo e della Chiesa, concedi a Elisa e Giovanni di esprimere nella vita il dono che ricevono nella fede.<br/> <br/>
        Per il nostro Signore Gesù Cristo, tuo Figlio, che è Dio, e vive e regna con te, nell' unità dello Spirito Santo, per tutti i secoli dei secoli.
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        <div className="libretto-chapter">
            <h1>
            LITURGIA DELLA PAROLA
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            PRIMA LETTURA
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">Dal libro del profeta Ezechiele (Ez 17, 22-24)</div>
        Così dice il Signore Dio:<br/>
        Un ramoscello io prenderò dalla cima del cedro,<br/>
        dalle punte dei suoi rami lo coglierò<br/>
        e lo pianterò sopra un monte alto, imponente;<br/>
        lo pianterò sul monte alto d' Israele.<br/>
        Metterà rami e farà frutti<br/>
        e diventerà un cedro magnifico.<br/>
        Sotto di lui tutti gli uccelli dimoreranno,<br/>
        ogni volatile all' ombra dei suoi rami riposerà.<br/>
        Sapranno tutti gli alberi della foresta<br/>
        che io sono il Signore,<br/>
        che umilio l' albero alto e innalzo l' albero basso,<br/>
        faccio seccare l' albero verde e germogliare l' albero secco. <br/>
        Io, il Signore, ho parlato e lo farò»<br/><br/>
        Parola di Dio
        <div className="libretto-risposta">- Rendiamo grazie a Dio</div><br/>
        </div>

        <div className="libretto-chapter">
            <h2>
            SALMO RESPONSORIALE
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">Del Tuo Spirito - dal Salmo 120</div>
        <div className="libretto-rit">
        RIT: Del tuo Spirito, Signore, <br/>
        <div className="libretto-rit2">è piena la terra, è piena la terra. <br/>
        Del tuo Spirito, Signore, <br/>
        è piena la terra, è piena la terra. <br/>
        </div></div>
        Benedici il Signore, anima mia,  <br/>
        Signore, Dio, tu sei grande! <br/>
        Sono immense, splendenti <br/>
        tutte le tue opere e tutte le creature. <br/>
        <div className="libretto-rit">RIT.</div>
        Se tu togli il tuo soffio muore ogni cosa  <br/>
        e si dissolve nella terra. <br/>
        Il tuo spirito scende: <br/>
        tutto si ricrea e tutto si rinnova. <br/>
        <div className="libretto-rit">RIT.</div>
        La tua gloria, Signore, resti per sempre. <br/>
        Gioisci, Dio, del creato.<br/>
        Questo semplice canto<br/>
        salga a te Signore, sei tu la nostra gioia.<br/>
        <div className="libretto-rit">RIT.</div>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            SECONDA LETTURA
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">Dalla prima lettera di Paolo ai Corinzi (1Cor 12, 31-13, 8a)</div>
        Fratelli, aspirate ai carismi più grandi!<br/>
        E io vi mostrerò una via migliore di tutte.<br/>
        Se anche parlassi le lingue degli uomini e degli angeli, ma non avessi la carità, sono come un bronzo che risuona o un cembalo che tintinna.<br/>
        E se avessi il dono della profezia e conoscessi tutti i misteri e tutta la scienza, e possedessi la pienezza della fede così da trasportare le montagne, ma non avessi la carità, non sono nulla.<br/>
        E se anche distribuissi tutte le mie sostanze e dessi il mio corpo per esser bruciato, ma non avessi la carità, niente mi giova.<br/>
        La carità è paziente, è benigna la carità; non è invidiosa la carità, non si vanta, non si gonfia, non manca di rispetto, non cerca il suo interesse, non si adira, non tiene conto del male ricevuto, non gode dell' ingiustizia, ma si compiace della verità. Tutto copre, tutto crede, tutto spera, tutto sopporta.<br/>
        La carità non avrà mai fine.<br/><br/>
        Parola di Dio
        <div className="libretto-risposta">- Rendiamo grazie a Dio</div><br/>
        </div>

        <div className="libretto-chapter">
            <h2>
            ALLELUIA
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">Alleluia, alleluia,<br/>
        Cantiamo al Signore, alleluia! <br/>
        Alleluia, alleluia!</div>
        Vieni, vieni, Spirito Santo, <br/>
        riempi i cuori dei tuoi fedeli<br/>
        e accendi il fuoco del tuo amore<br/>
        <div className="libretto-rit">Alleluia, alleluia,<br/>
        Cantiamo al Signore, alleluia! <br/>
        Alleluia, alleluia!</div>
        </div>

        <div className="libretto-chapter">
            <h2>
            VANGELO
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">Dal Vangelo secondo Luca (Lc 14, 1.12-23)</div>
        
        Un sabato Gesu si recò a casa di uno dei capi dei farisei per pranzare ed essi stavano a osservarlo. Disse poi a colui che lo aveva invitato: «Quando offri un pranzo o una cena, non invitare i tuoi amici, né i tuoi fratelli, né i tuoi parenti, né i ricchi vicini, perché anch' essi non ti invitino a loro volta e tu abbia il contraccambio. Al contrario, quando dai un banchetto, invita poveri, storpi, zoppi, ciechi; e sarai beato perché non hanno da ricambiarti. Riceverai infatti la tua ricompensa alla risurrezione dei giusti».<br/><br/>
        Uno dei commensali, avendo udito ciò, gli disse: «Beato chi mangerà il pane nel regno di Dio!». Gesù rispose: «Un uomo diede una grande cena e fece molti inviti. All' ora della cena, mandò il suo servo a dire agli invitati: Venite, è pronto. Ma tutti, all' unanimità, cominciarono a scusarsi. Il primo disse: Ho comprato un campo e devo andare a vederlo; ti prego, considerami giustificato. Un altro disse: Ho comprato cinque paia di buoi e vado a provarli; ti prego, considerami giustificato. Un altro disse: Ho preso moglie e perciò non posso venire. Al suo ritorno il servo riferì tutto questo al padrone. Allora il padrone di casa, irritato, disse al servo: Esci subito per le piazze e per le vie della città e conduci qui poveri, storpi, ciechi e zoppi. Il servo disse: Signore, è stato fatto come hai ordinato, ma c' è ancora posto. Il padrone allora disse al servo: Esci per le strade e lungo le siepi, spingili a entrare, perché la mia casa si riempia!».<br/><br/>
        Parola del Signore <div className="libretto-risposta">- Lode a te, o Cristo</div><br/>
        </div>


        <div className="libretto-chapter">
            <h1>
            RITO DEL MATRIMONIO 
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            INTERROGAZIONE PRIMA DEL CONSENSO
          </h2>
        </div>
        <div className="libretto-body">
        Carissimi Elisa e Giovanni, siete venuti insieme nella casa del Padre, <br/>
        perché la vostra decisione di unirvi in Matrimonio<br/>
        riceva il suo sigillo e la sua consacrazione,<br/>
        davanti al ministro della Chiesa e davanti alla comunità.<br/>
        Voi siete già consacrati mediante il Battesimo:<br/>
        ora Cristo vi benedice e vi rafforza con il sacramento nuziale, <br/>
        perché vi amiate l' un l' altro con amore fedele e inesauribile<br/>
        e assumiate responsabilmente i doveri del Matrimonio.<br/><br/>
        Pertanto vi chiedo di esprimere davanti alla Chiesa le vostre intenzioni.<br/><br/>
        <div className="libretto-risposta">Elisa e Giovanni:</div>
        Compiuto il cammino del fidanzamento,<br/>
        illuminati dallo Spirito Santo<br/>
        e accompagnati dalla comunità cristiana,<br/>
        siamo venuti in piena libertà<br/>
        nella casa del Padre<br/>
        perché il nostro amore riceva il sigillo di consacrazione.<br/><br/>
        Consapevoli della nostra decisione, siamo disposti,<br/>
        con la grazia di Dio,<br/>
        ad amarci e sostenerci l' un l' altro per tutti i giorni della vita.<br/><br/>
        Ci impegniamo ad accogliere con amore i figli che Dio vorrà donarci<br/>
        e a educarli secondo la Parola di Cristo<br/>
        e l' insegnamento della Chiesa.<br/>
        Chiediamo a voi, fratelli e sorelle,<br/>
        di pregare con noi e per noi<br/>
        perché la nostra famiglia<br/>
        diffonda nel mondo luce, pace e gioia.<br/><br/>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            MANIFESTAZIONE DEL CONSENSO
          </h2>
        </div>
        <div className="libretto-body">
        Se dunque è vostra intenzione unirvi in Matrimonio, datevi la mano destra
        ed esprimete davanti a Dio e alla sua Chiesa
        il vostro consenso.<br/>
        <div className="libretto-risposta">Giovanni:</div>
        Io, Giovanni, accolgo te, Elisa, come mia sposa. <br/>
        Con la grazia di Cristo<br/>
        prometto di esserti fedele sempre,<br/>
        nella gioia e nel dolore,<br/>
        nella salute e nella malattia,<br/>
        e di amarti e onorarti<br/>
        tutti i giorni della mia vita.<br/>
        <div className="libretto-risposta">Elisa:</div>
        Io, Elisa, accolgo te, Giovanni, come mio sposo. <br/>
        Con la grazia di Cristo<br/>
        prometto di esserti fedele sempre,<br/>
        nella gioia e nel dolore,<br/>
        nella salute e nella malattia,<br/>
        e di amarti e onorarti<br/>
        tutti i giorni della mia vita.<br/><br/>
        Il Signore onnipotente e misericordioso confermi il consenso<br/>
        che avete manifestato davanti alla Chiesa<br/>
        e vi ricolmi della sua benedizione.<br/>
        L' uomo non osi separare ciò che Dio unisce.
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            BENEDIZIONE E CONSEGNA DEGLI ANELLI
          </h2>
        </div>
        <div className="libretto-body">
        Signore, benedici questi anelli nuziali:<br/>
        gli sposi che li porteranno<br/>
        custodiscano integra la loro fedeltà, rimangano nella tua volontà e nella tua pace e vivano sempre nel reciproco amore.<br/>
        Per Cristo nostro Signore. <div className="libretto-risposta">- Amen</div><br/>
        <div className="libretto-risposta">Giovanni:</div>
        Elisa, ricevi questo anello,<br/>
        segno del mio amore e della mia fedeltà.<br/>
        Nel nome del Padre e del Figlio e dello Spirito Santo.<br/>
        <div className="libretto-risposta">Elisa:</div>
        Giovanni, ricevi questo anello,<br/>
        segno del mio amore e della mia fedeltà.<br/>
        Nel nome del Padre e del Figlio e dello Spirito Santo.<br/><br/>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            BENEDIZIONE NUZIALE
          </h2>
        </div>
        <div className="libretto-body">
        Fratelli e sorelle,<br/>
        raccolti in preghiera, invochiamo su questi sposi, Elisa e Giovanni,<br/>
        la benedizione di Dio: egli, che oggi li ricolma di grazia con il sacramento del Matrimonio, li accompagni sempre con la sua protezione.<br/><br/>
        <span style={{ fontStyle: 'italic' }}>(Tutti pregano per breve tempo in silenzio)<br/></span><br/>
        Padre santo, creatore dell' universo,<br/>
        che hai formato l' uomo e la donna a tua immagine e hai voluto benedire la loro unione, ti preghiamo umilmente per questi tuoi figli, che oggi si uniscono con il sacramento nuziale.<br/>
        Scenda, o Signore, su questi sposi Elisa e Giovanni la ricchezza delle tue benedizioni, e la forza del tuo Santo Spirito infiammi dall' alto i loro cuori, perché nel dono reciproco dell' amore allietino di figli la loro famiglia e la comunità ecclesiale.<br/><br/>
        Ti lodino, Signore, nella gioia,<br/>
        ti cerchino nella sofferenza;<br/>
        godano del tuo sostegno nella fatica<br/>
        e del tuo conforto nella necessità;<br/>
        ti preghino nella santa assemblea,<br/>
        siano tuoi testimoni nel mondo.<br/>
        Vivano a lungo nella prosperità e nella pace e, con tutti gli amici che ora li circondano, giungano alla felicità del tuo regno.<br/><br/>
        Per Cristo nostro Signore.
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            BENEDICAT
          </h2>
        </div>
        <div className="libretto-body">
        Benedicat tibi Dominus et custodiat te, <br/>
        ostendat faciem suam tibi et misereatur tui <br/>
        convertat vultum suum ad te et det tibi pacem. <br/>
        Dominus benedicat frater Leo, te.
        <div className="libretto-rit">Benedicat, benedicat,<br/>
        benedicat tibi Dominus et custodiat te.<br/></div>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            PREGHIERE DEI FEDELI
          </h2>
        </div>
        <div className="libretto-body">
        Invochiamo Dio, nostro Padre, sorgente inesauribile dell' amore, perché sostenga questi sposi
        nel cammino che oggi hanno iniziato.<br/><br/>
        Preghiamo insieme e diciamo: <div className="libretto-risposta">- Ascoltaci, Signore</div><br/>
        </div>
        
        
        <div className="libretto-chapter">
            <h2>
            INVOCAZIONE DEI SANTI
          </h2>
        </div>
        <div className="libretto-body">
        Ora in comunione con la Chiesa del cielo, invochiamo l' intercessione dei santi.
        <div className="libretto-rit">RIT. E voi tutti uomini e donne che donate la vostra vita con amore, pregate per noi<br/></div>
        
        Maria, docile ancella dello Spirito<br/>
        Giuseppe, sposo giusto e fedele<br/>
        Michele, Gabriele e Raffaele araldi della parola di Dio <br/>
        Patriarchi e profeti, che avete atteso il Cristo <br/>
        Giovanni Battista, voce di uno che grida nel deserto <br/>
        Gioacchino e Anna, modello di amore familiare <br/>
        Zaccaria ed Elisabetta, tenaci nella fedeltà<br/>
        <div className="libretto-rit">RIT. E voi tutti uomini e donne che donate la vostra vita con amore, pregate per noi<br/></div>
        Pietro, roccia della Chiesa<br/>
        Paolo, coraggioso testimone della fede<br/>
        Santi apostoli che avete udito, visto e creduto<br/>
        Santi evangelisti che avete custodito e proclamato la buona notizia <br/>
        Maria Maddalena, prima testimone del Risorto<br/>
        Marta, alacre ascoltatrice di Cristo<br/>
        Voi tutte donne che avete seguito Gesù<br/>
        <div className="libretto-rit">RIT. E voi tutti uomini e donne che donate la vostra vita con amore, pregate per noi<br/></div>

        Francesco, povero di Dio in perfetta letizia<br/>
        Faustino e Giovita, difensori della giustizia <br/>
        Geminiano, vescovo e protettore della nostra Chiesa <br/>
        Giovanni Paolo II, messaggero di pace<br/>
        Elisa, soccorritrice dei poveri e degli ammalati<br/>
        Voi ultimi che avete sperato nel Signore<br/>
        Voi tutti santi e sante della Chiesa<br/>
        <div className="libretto-rit">RIT. E voi tutti uomini e donne che donate la vostra vita con amore, pregate per noi<br/></div>
        Effondi, Signore, su Elisa e Giovanni lo Spirito del tuo amore, perché diventino un cuor solo e un' anima sola: nulla separi questi sposi che tu hai unito e, ricolmati della tua benedizione, nulla li affligga. <br/><br/>
        Per Cristo, nostro Signore.
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            PROFESSIONE DI FEDE
          </h2>
        </div>
        <div className="libretto-body">
        Io credo in Dio,<br/>
        Padre onnipotente, creatore del cielo e della terra; <br/>
        e in Gesù Cristo, suo unico Figlio, nostro Signore, <br/>
        il quale fu concepito di Spirito Santo,<br/>
        nacque da Maria Vergine,<br/>
        patì sotto Ponzio Pilato,<br/>
        fu crocifisso, morì e fu sepolto; discese agli inferi; <br/>
        il terzo giorno riscuscitò da morte; salì al cielo, <br/>
        siede alla destra di Dio Padre onnipotente;<br/>
        di là verrà a giudicare i vivi e i morti.<br/>
        Credo nello Spirito Santo,<br/>
        la santa Chiesa cattolica,<br/>
        la comunione dei santi,<br/>
        la remissione dei peccati,<br/>
        la risurrezione della carne,<br/>
        la vita eterna. Amen.<br/><br/><br/>
        </div>

        
        
        <div className="libretto-chapter">
            <h1>
            LITURGIA EUCARISTICA
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            SERVO PER AMORE
          </h2>
        </div>
        <div className="libretto-body">
        Una notte di sudore<br/>
        sulla barca in mezzo al mare<br/>
        e mentre il cielo si imbianca già, tu guardi le tue reti vuote.<br/>
        Ma la voce che ti chiama<br/>
        un altro mare ti mostrerà<br/>
        e sulle rive di ogni cuore,<br/>
        le tue reti getterai.<br/>
        <div className="libretto-rit">
        RIT: Offri la vita tua come Maria <br/>
        <div className="libretto-rit2">ai piedi della croce<br/>
        e sarai servo di ogni uomo, <br/>
        servo per amore, <br/>
        sacerdote dell' umanità.</div></div>
        Avanzavi nel silenzio<br/>
        fra le lacrime e speravi<br/>
        che il seme sparso davanti a Te cadesse sulla buona terra.<br/>
        Ora il cuore tuo è in festa<br/>
        perché il grano biondeggia ormai, è maturato sotto il sole,<br/>
        puoi riporlo nei granai.
        <div className="libretto-rit">RIT.</div>
        </div>

        <div className="libretto-chapter">
            <h2>
            AGNELLO DI DIO
          </h2>
        </div>
        <div className="libretto-body">
        Agnello di Dio che togli i peccati del mondo, <br/>Abbi pietà di noi. Abbi pietà di noi.<br/><br/>
        Agnello di Dio, che togli i peccati del mondo, <br/>Abbi pietà di noi. Abbi pietà di noi.<br/><br/>
        Agnello di Dio che togli i peccati del mondo, <br/>Dona a noi la pace. Dona a noi la pace.<br/><br/>
        </div>

        
        
        <div className="libretto-chapter">
            <h1>
            CANTI DI COMUNIONE
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            GLORIA DAL BASSO DELLA TERRA
          </h2>
        </div>
        <div className="libretto-body">
        Gloria dal basso della Terra,<br/>
        gloria dal più infame degli stermini.<br/>
        Gloria nella carestia,<br/>
        gloria nella guerra più atroce.<br/>
        Gloria, gloria, gloria,<br/>
        solo tu hai la forza con la tua gloria<br/>
        di asciugare le lacrime, di portare nella tua gloria nell' alto dei cieli i vinti della terra,<br/>
        i vinti della terra, i vinti della terra.<br/><br/>
        </div>
        <div className="libretto-chapter">
            <h2>
            LODE AL NOME TUO
          </h2>
        </div>
        <div className="libretto-body">
        Lode al nome tuo dalle terre più floride <br/>
        Dove tutto sembra vivere, lode al nome tuo <br/>
        Lode al nome tuo dalle terre più aride<br/>
        Dove tutto sembra sterile, lode al nome tuo<br/>
        <div className="libretto-rit">
        RIT: Tornerò a lodarti sempre per ogni dono tuo<br/>
        <div className="libretto-rit2">E quando scenderà la notte, sempre io dirò <br/>
        “Benedetto il nome del Signor<br/>
        Lode al nome tuo<br/>
        Benedetto il nome del Signor<br/>
        Il glorioso nome di Gesù”</div></div>
        Lode al nome tuo quando il sole splende su di me <br/>
        Quando tutto è incantevole, lode al nome tuo <br/>
        Lode al nome tuo quando io sto davanti a te<br/>
        Con il cuore triste e fragile, lode al nome tuo<br/>
        <div className="libretto-rit">RIT.</div>
        Tu doni e porti via <br/>
        Tu doni e porti via <br/>
        Ma sempre sceglierò<br/>
        Di benedire te<br/>
        <div className="libretto-rit">RIT.</div>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            ORAZIONE DOPO LA COMUNIONE
          </h2>
        </div>
        <div className="libretto-body">
        O Padre, che ci hai accolto alla tua mensa, concedi a questa nuova famiglia consacrata dalla tua benedizione di esserti sempre fedele e di testimoniare il tuo amore nella comunità dei fratelli.
        Per Cristo nostro Signore. <div className="libretto-risposta">- Amen</div><br/>
        </div>
        
        <div className="libretto-chapter">
            <h2>
            RITI DI CONCLUSIONE
          </h2>
        </div>
        <div className="libretto-body">
        Il Signore Gesù,
        che santificò le nozze di Cana,
        benedica voi, le vostre famiglie e i vostri amici. <div className="libretto-risposta">- Amen</div><br/>
        Cristo, che ha amato la sua Chiesa sino alla fine, effonda continuamente nei vostri cuori
        il suo stesso amore.
        <div className="libretto-risposta">- Amen</div><br/>
        Il Signore conceda a voi,
        che testimoniate la fede nella sua risurrezione,
        di attendere nella gioia che si compia la beata speranza. <div className="libretto-risposta">- Amen</div><br/>
        E su voi tutti,
        che avete partecipato a questa liturgia nuziale, scenda la benedizione di Dio onnipotente, Padre e Figlio e Spirito Santo.
        <div className="libretto-risposta">- Amen</div><br/>
        </div>

        
        
        <div className="libretto-chapter">
            <h1>
            CANTI FINALI
          </h1>
        </div>
        <div className="libretto-chapter">
            <h2>
            RESTA QUI CON NOI
          </h2>
        </div>
        <div className="libretto-body">
        Le ombre si distendono scende ormai la sera <br/>
        e si allontanano dietro i monti<br/>
        i riflessi di un giorno che non finirà,<br/>
        di un giorno che ora correrà sempre<br/>
        perché sappiamo che una nuova vita <br/>
        da qui è partita e mai più si fermerà.<br/>
        <div className="libretto-rit">RIT: Resta qui con noi il sole scende già,<br/>
        <div className="libretto-rit2">resta qui con noi Signore è sera ormai.<br/>
        Resta qui con noi il sole scende già, <br/>
        se tu sei fra noi la notte non verrà.<br/></div></div>
        S' allarga verso il mare il tuo cerchio d' onda <br/>
        che il vento spingerà fino a quando <br/>
        giungerà ai confini di ogni cuore,<br/>
        alle porte dell' amore vero;<br/>
        come una fiamma che dove passa brucia, <br/>
        così il Tuo amore tutto il mondo invaderà.<br/>
        <div className="libretto-rit">RIT.</div>
        Davanti a noi l' umanità lotta, soffre e spera <br/>
        come una terra che nell' arsura<br/>
        chiede l' acqua da un cielo senza nuvole, <br/>
        ma che sempre le può dare vita.<br/>
        Con Te saremo sorgente d' acqua pura, <br/>
        con Te fra noi il deserto fiorirà.<br/>
        <div className="libretto-rit">RIT.</div>
        </div>

        
        <div className="libretto-chapter">
            <h2>
            IL CANTO DEL TUO POPOLO
          </h2>
        </div>
        <div className="libretto-body">
        <div className="libretto-rit">
        RIT: Salga a te, Signore, il canto del tuo popolo <br/>
        <div className="libretto-rit2">Con la forza del tuo Spirito che grida in noi <br/>
        Innalziam le nostre mani verso te, Gesù <br/>
        Per offrirti il sacrificio della lode</div></div>
        Tu sei la nostra vita, luce che non svanirà <br/>
        Verbo eterno, salvatore dell' umanità<br/>
        Il cuore di ogni uomo accolga la tua verità<br/>
        La gloria tua nel mondo senza fine splenderà<br/>
        <div className="libretto-rit">RIT.</div>
        Tu sei il buon pastore che la via ci mostrerà <br/>
        Guidi i nostri passi nella vera libertà<br/>
        Tu sei promessa eterna, fonte di felicità<br/>
        A te leviamo i cuori e ti adoriamo, maestà<br/>
        <div className="libretto-rit">RIT.</div>
        </div>
      
        <div className="libretto-chapter">
            <h1>
            THE END
          </h1>
        </div>
        <div className="libretto-body">
        Visualizzare questa schermata <a href="https://www.websitecarbon.com/website/giocotta-it-libretto/" target="_blank" rel="noopener noreferrer">ha prodotto</a> ~0.1g di CO2. <br/>
        Stampare il libretto in copisteria <a href="https://www.ezeep.com/co2-neutral-printing/" target="_blank" rel="noopener noreferrer">ne avrebbe prodotti</a> ~30g. Grazie 🌱
        </div>
    </section>
  );
};

export default Libretto;